import { createResetStateMutation } from '@/helpers';
import { getInitialStateHipoteca } from './state';

export const setLocaciones = (state, payload) => {
   state.locaciones = Array.isArray(payload) ? payload : [];
};

export const setLocacionEditandoId = (state, payload) => {
   state.locacionEditandoId = payload;
};

export const setDocumentos = (state, payload) => {
   state.documentos = Array.isArray(payload) ? payload : [];
};

export const setLoading = (state, payload) => {
   state.loading = Boolean(payload);
};

export const resetState = createResetStateMutation(getInitialStateHipoteca);
